import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Card, Button, Input, Checkbox } from 'components';
import { AiFillCloseCircle } from 'react-icons/ai';
import Form from 'react-bootstrap/Form';
import { parseHsppId, renderStatusColorClass } from 'services/helpers';

import ButtonBTN from 'react-bootstrap/Button';
const ChooseAuthenticationModal = ({ _this }) => {
  return (
    <Modal
      style={{ zIndex: 9999 }}
      show={_this.chooseAuthenticationModalVisbility}
      onHide={() => _this.setChooseAuthenticationModalVisibility(false)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      // backdrop={'static'}
      // keyboard={false}
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">
          Choose an authentication system for your account
        </Modal.Title>
        <AiFillCloseCircle
          size={30}
          onClick={() => _this.setChooseAuthenticationModalVisibility(false)}
        />
      </Modal.Header>
      <Modal.Body className="flex flex-row">
        <Card className="">
          <div className="flex justify-between items-center gap-4">
            <Checkbox
              label={<p className="text-sm tracking-tight">Send OTP to your work email (OTP)</p>}
              className="mt-3 mx-auto text-base"
              type="checkbox"
              onChange={(e) =>
                e.target.checked == true && _this.chooseAuthenticationSystemSubmit('OTP')
              }
            />
            <Checkbox
              label={
                <p className="text-sm tracking-tight">Authenticator App on your phone (2FA)</p>
              }
              className="mt-3 mx-auto text-base"
              type="checkbox"
              onChange={(e) =>
                e.target.checked == true && _this.chooseAuthenticationSystemSubmit('2FA')
              }
            />
          </div>
          {/* <div className="text-md text-slate-500 mt-1 flex flex-col gap-4">
            {_this.customerAccountsModalDetails?.accountDetails?.map((item, index) => (
              <div
                className="bg-slate-100 px-3 py-2 rounded flex flex-col gap-2 cursor-pointer"
                key={index}
                onClick={() => _this.customerSelectAccountSubmit(item)}
              >
                <div className="flex justify-between items-center">
                  <div className="leading-tight">
                    <p className="font-bold text-lg text-slate-600">{item.customer_name}</p>
                    <p className="">({item.user_name})</p>
                  </div>

                  <div className="flex flex-row items-center justify-between">
                    <span
                      className={`${renderStatusColorClass(
                        item?.status === 'Active' ? 'Active' : 'Cancelled'
                      )} font-semibold rounded text-xs`}
                    >
                      <span className="font-bold text-sm uppercase">{item.status}</span>
                    </span>
                  </div>
                </div>

                <div className="flex justify-between items-center">
                  <p>{item.email}</p>
                  <p className="font-bold text-sm text-slate-600">{item.customer_id}</p>
                </div>
              </div>
            ))}
          </div> */}
        </Card>
      </Modal.Body>
      {/* <Modal.Footer>
        <Button
          onClick={() => {
            // _this.handelChangePasswordSubmit();
          }}
        >
          Change Password
        </Button>
      </Modal.Footer> */}
    </Modal>
  );
};

export default ChooseAuthenticationModal;
